import { useTranslation } from "react-i18next";
import SearchIcon from "../../../../icons/searchIcon";
import Select from "../../../../components/select/select";
import DataTable from "../../../../components/table/dataTable";
import EyeIcon from "../../../../icons/eyeIcon";
import EditIcon from "../../../../icons/editIcon";

const LastUpdatedShipments = () => {
  const { t } = useTranslation();

  const deliveryStatusOptions = [
    { label: t("all"), value: "all" },
    { label: t("delivered"), value: "delivered" },
    { label: t("inPort"), value: "in_port" },
    { label: t("shippingInProgress"), value: "shipping_in_progress" },
  ];
  const citiesOptions = [
    { label: "All", value: "all" },
    { label: "Paris", value: "paris" },
    { label: "dubai", value: "dubai" },
    { label: "Istanbul", value: "istanbul" },
    { label: "London", value: "london" },
  ];
  const tableHead = [
    { header: t("shipmentNumber"), accessorKey: "shipmentNumber" },
    { header: t("customerName"), accessorKey: "customerName" },
    { header: t("shipmentDate"), accessorKey: "shipmentDate" },
    { header: t("destination"), accessorKey: "destination" },
    { header: t("currentStatus"), accessorKey: "currentStatus" },
    { header: t("type"), accessorKey: "type" },
    { header: t("actions"), accessorKey: "actions" },
  ];
  const shipmentData = [
    {
      shipmentNumber: "ORDER1001",
      customerName: "علي ياسر",
      shipmentDate: "27/07/2024",
      destination: "باريس",
      currentStatus: "تم التسليم",
      type: "عادي",
      actions: "تفاصيل",
    },
    {
      shipmentNumber: "ORDER1002",
      customerName: "محمد أحمد",
      shipmentDate: "28/07/2024",
      destination: "لندن",
      currentStatus: "جاري الشحن",
      type: "مستعجل",
      actions: "تتبع",
    },
    {
      shipmentNumber: "ORDER1003",
      customerName: "سارة خالد",
      shipmentDate: "29/07/2024",
      destination: "اسطنبول",
      currentStatus: "في الميناء",
      type: "عادي",
      actions: "إلغاء",
    },
    {
      shipmentNumber: "ORDER1004",
      customerName: "نورا عبدالله",
      shipmentDate: "30/07/2024",
      destination: "دبي",
      currentStatus: "متأخر",
      type: "مستعجل",
      actions: "تعديل",
    },
  ];
  const tableData = shipmentData.map((d, i) => {
    const destination = (
      <span className="font-medium text-mainBlue">{d.destination}</span>
    );
    const currentStatus = (
      <span className="py-2 w-[100px] block mx-auto rounded-lg bg-[#E6F4EF]">
        {d.currentStatus}
      </span>
    );
    const actions = (
      <div className="flex items-center justify-center gap-2">
        <EyeIcon className="cursor-pointer" />
        <EditIcon className="cursor-pointer" />
      </div>
    );
    return {
      shipmentNumber: d.shipmentNumber,
      customerName: d.customerName,
      shipmentDate: d.shipmentDate,
      destination,
      currentStatus,
      type: d.type,
      actions,
    };
  });
  return (
    <div className="min-w-full p-5 capitalize bg-white rounded-2xl">
      <section className="flex border-b border-b-[#888888] pb-2 items-center justify-between">
        <div className="font-medium">{t("lastUpdatedShipments")}</div>
        <div className="flex border  border-[#F9F9F9] focus-within:border-black items-center gap-4 bg-[#F9F9F9] rounded-full px-4">
          <SearchIcon />
          <input
            type="text"
            className="flex-1 py-2 bg-transparent focus:border-none focus-visible:outline-none"
            placeholder={t("searchShipment")}
          />
        </div>
        <div className="flex items-center justify-center gap-1">
          <Select options={deliveryStatusOptions} placeholder={t("status")} />
          <Select options={citiesOptions} placeholder={t("destination")} />
        </div>
      </section>
      <div className="min-w-full my-5 overflow-x-auto">
        <DataTable TableHead={tableHead} TableData={tableData} />
      </div>
    </div>
  );
};

export default LastUpdatedShipments;
